import React from 'react';
import StepHeader from './StepHeader';
import Button from '../../lib/ui/Button';
import { UNIT_CONFIG } from '../../lib/format';

export default function CartStep({ cart, total, te, L, t, onClose, onContinue }) {
  return (
    <div>
      <StepHeader title={`🛒 ${L('Review Order', 'ఆర్డర్ సమీక్షించండి')}`} onClose={onClose} />
      <div className="bg-brand-light/30 border border-black/5 rounded-2xl px-3.5 py-2.5">
        {cart.map((item) => {
          const lbl = (UNIT_CONFIG[item.unit] || UNIT_CONFIG.kg).label;
          return (
            <div key={item.product_id} className="flex items-center gap-2 py-1.5 border-b border-black/5 last:border-0">
              <span className="flex-1 font-bold text-[13px] text-ink truncate">{te ? item.product_name_te : item.product_name}</span>
              <span className="text-ink-faint text-xs min-w-[44px] text-right">{item.quantity_kg}{lbl}</span>
              <span className="font-extrabold text-brand-dark text-[13px] min-w-[48px] text-right">₹{item.subtotal.toFixed(0)}</span>
            </div>
          );
        })}
        <div className="flex justify-between items-center mt-2 pt-2 border-t border-black/10">
          <span className="font-extrabold text-ink">{t.total}</span>
          <span className="font-black text-xl text-ink">₹{total.toFixed(2)}</span>
        </div>
      </div>
      <div className="flex gap-2.5 mt-4">
        <Button variant="danger" onClick={onClose}>✕ {L('Cancel', 'రద్దు')}</Button>
        <Button variant="accent" className="flex-[2]" onClick={onContinue}>{L('Continue →', 'కొనసాగించు →')}</Button>
      </div>
    </div>
  );
}
